import { PartialType } from '../../../utils';
import { CreateRentalLocationDto } from './create-rental-location.dto';
export class UpdateRentalLocationDto extends PartialType(CreateRentalLocationDto) {
}
